/**
 * god-entity lint rule — flags entities that have grown too many fields or
 * too many incoming references. These are refactor candidates: split the
 * entity into smaller documents or extract sub-models.
 */
import type { AtlasManifest } from '../types.js';

export const GOD_ENTITY_FIELD_THRESHOLD = 20;
export const GOD_ENTITY_INCOMING_REF_THRESHOLD = 15;

export interface GodEntityFinding {
  ref: string;
  message: string;
}

export function godEntity(manifest: AtlasManifest): GodEntityFinding[] {
  const incomingByEntity = new Map<string, number>();
  for (const r of manifest.references) {
    if (r.from === r.to) continue;
    incomingByEntity.set(r.to, (incomingByEntity.get(r.to) ?? 0) + 1);
  }

  const findings: GodEntityFinding[] = [];
  for (const entity of manifest.entities) {
    const fieldCount = entity.fields.length;
    const incoming = incomingByEntity.get(entity.id) ?? 0;
    if (fieldCount > GOD_ENTITY_FIELD_THRESHOLD) {
      findings.push({
        ref: entity.id,
        message: `${entity.id} has ${fieldCount} fields (>${GOD_ENTITY_FIELD_THRESHOLD}) — consider extracting sub-entities`,
      });
    } else if (incoming > GOD_ENTITY_INCOMING_REF_THRESHOLD) {
      findings.push({
        ref: entity.id,
        message: `${entity.id} has ${incoming} incoming refs (>${GOD_ENTITY_INCOMING_REF_THRESHOLD}) — high coupling, consider splitting`,
      });
    }
  }
  return findings;
}
